module.exports = __webpack_public_path__ + "static/logo-ink-c383572a5932172d1a8d5e1c852bf3d5.svg";